export const BASE_URL = 'https://final-project-backend-3hml5rsopa-no.a.run.app';

export const API_URL = (slug) => `${BASE_URL}/${slug}`